import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  CreateQuizStackBlockDTO,
  QuizBlockStackDTO,
} from '@app/infrastructure/models/quiz-stack-block';
import { BLOCK_TYPES } from '@app/infrastructure/utils/constants';

@Component({
  selector: 'app-quiz-stack-block-viewer',
  templateUrl: './quiz-stack-block-viewer.component.html',
  styleUrls: ['./quiz-stack-block-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuizStackBlockViewer {
  @Input() block: QuizBlockStackDTO;
  public blockTypeEnum = BLOCK_TYPES;
}
